import React from "react";
import { useNavigate } from "react-router-dom";
import { formatUserName } from "../../utils/helpers";
import { useLocalization } from "../../context/LocalizationContext";
import { usePodIP } from "../../hooks/usePodIP";
import "./Dashboard.css";
import ActivityIcon from "../../assets/icons/activity.svg";
import VideoRecorderIcon from "../../assets/icons/video-recorder.svg";
import FileIcon from "../../assets/icons/file.svg";
import ChatIcon from "../../assets/icons/chat.svg";
import BookIcon from "../../assets/icons/book.svg";
import EndIcon from "../../assets/icons/end.svg";
import Header from "../shared/Header/index";
import LanguageToggle from "../shared/LanguageToggle";

const Dashboard = ({ userData }) => {
  const navigate = useNavigate();
  const { t } = useLocalization();
  const { podIP } = usePodIP();

  // Button configuration with localized labels
  const BUTTON_CONFIG = [
    {
      id: "vitals",
      icon: ActivityIcon,
      label: t("dashboard.checkVitals"),
      ariaLabel: t("dashboard.checkVitals"),
      action: "navigate",
      route: "/vitals",
    },
    {
      id: "consultation",
      icon: VideoRecorderIcon,
      label: t("dashboard.joinConsultation"),
      ariaLabel: t("dashboard.joinConsultation"),
      action: "navigate",
      route: "/consultation",
    },
    {
      id: "assessment",
      icon: FileIcon,
      label: t("dashboard.healthAssessment"),
      ariaLabel: t("dashboard.healthAssessment"),
      action: "navigate",
      route: "/assessment",
    },
    {
      id: "chat",
      icon: ChatIcon,
      label: t("dashboard.chatManager"),
      ariaLabel: t("dashboard.chatManager"),
      action: "navigate",
      route: "/chat-manager",
    },
    {
      id: "knowledge",
      icon: BookIcon,
      label: t("dashboard.knowledgeBank"),
      ariaLabel: t("dashboard.knowledgeBank"),
      action: "placeholder",
      message: t("dashboard.knowledgeBank") + " clicked",
    },
    {
      id: "end",
      icon: EndIcon,
      label: t("dashboard.endSession"),
      ariaLabel: t("dashboard.endSession"),
      action: "navigate",
      route: "/end",
    },
  ];

  // Filter buttons based on pod IP
  const getFilteredButtons = () => {
    if (podIP == "192.168.1.200") {
      // Show all 6 buttons
      return BUTTON_CONFIG;
    } else {
      // Show only 4 buttons: vitals, consultation, assessment, end
      return BUTTON_CONFIG.filter((config) =>
        ["vitals", "consultation", "assessment", "end"].includes(config.id)
      );
    }
  };

  const handleButtonClick = (config) => {
    if (config.action === "navigate") {
      navigate(config.route);
    } else if (config.action === "placeholder") {
      console.log(config.message);
    }
  };

  return (
    <div className="main-container">
      <Header
        text={t("dashboard.welcomeMessage", {
          name: formatUserName(userData?.name),
        })}
      />
      <div className="dashboard-content">
        <div className="action-buttons">
          {getFilteredButtons().map((config) => (
            <button
              key={config.id}
              className="action-btn"
              onClick={() => handleButtonClick(config)}
              aria-label={config.ariaLabel}
            >
              <img src={config.icon} alt={config.label} className="btn-icon" />
              <span>{config.label}</span>
            </button>
          ))}
        </div>
        <div>
          <LanguageToggle />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
